
































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Achat} from '@/models';

import CrudAchatFilter from '@/components/Crud/Achat/Filter.vue';
import CrudAchatEditDialog from '@/components/Crud/Achat/EditDialog.vue';
import CrudAchatList from '@/components/Crud/Achat/List.vue';

import storeAchat, {AchatFilter} from '@/stores/modules/achat';

@Component({
	components: {
		CrudAchatFilter,
		CrudAchatEditDialog,
		CrudAchatList,
	}
})
export default class AchatListView extends Vue {

	@Stored(() => storeAchat) private achats!: ResultType<Achat>;
	@Stored(() => storeAchat) private filters!: AchatFilter;

	private imgPath: string = "";

	private editAchat: Achat = null;
	private storeAchat = storeAchat;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editAchat = new Achat();
		this.refresh();
	}

	private refresh(): void {
		storeAchat.dispatch('getC', { filters: true });
	}
}
